export enum UserRole {
    admin = 'ADMIN',
    seller = 'SELLER',
    vendorMgr = 'VENDORMGR',
    buyer = 'BUYER',
    sales = 'SALES',
    super = 'SUPER'
}
